/* eslint-disable camelcase */
import api from './api';

export const Proposal = async (empresa_id, proposta_id) => {
  try {
    const { data } = await api.post('/wf/proposal', { empresa_id, proposta_id });
    if (data) {
      return data[0];
    }
    return null;
  } catch (error) {
    return null;
  }
};
